document.addEventListener("DOMContentLoaded", () => {
  const dropdown = document.querySelector(".boa-custom-dropdown");
  // Initialize each dropdown
  if (dropdown) {
    initializeDropdown(dropdown);
  }
  // Setup escape key handler
  setupEscapeKeyHandler();

  // In-stock checkbox filter
  const inStockCheckbox = document.getElementById("boa-in-stock-filter");
  if (inStockCheckbox) {
    if (new URLSearchParams(window.location.search).get("inStock") === "true") {
      inStockCheckbox.checked = true;
    }
    inStockCheckbox.addEventListener("change", () => {
      const url = new URL(window.location.href);
      if (inStockCheckbox.checked) {
        url.searchParams.set("inStock", "true");
      } else {
        url.searchParams.delete("inStock");
      }
      url.searchParams.delete("page");
      window.history.replaceState({}, "", url.toString());

      const searchQuery = url.searchParams.get("q");
      const filters = {
        catalog: url.searchParams.get("catalog") || null,
        sortBy: url.searchParams.get("sortBy") || null,
        inStock: inStockCheckbox.checked || null,
      };

      const collectionElements = document.querySelector(".boa-collection-banner-container");
      if (collectionElements) {
        const { collectionId } = collectionElements.dataset;
        fetchCollectionSearchResults(collectionId, 1, searchQuery, filters);
      } else {
        fetchSearchResults(1, searchQuery, filters);
      }
    });
  }
});

function initializeDropdown(dropdown) {
  const selectedEl = dropdown.querySelector(".dropdown-selected");
  const options = dropdown.querySelectorAll(".dropdown-option");
  const selectedText = dropdown.querySelector(".selected-text");

  setDefaultOption(dropdown, options, selectedText);

  checkUrlForSelection(dropdown, options);

  selectedEl.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdown.classList.toggle("open");
  });

  selectedEl.addEventListener("blur", (e) => {
    e.stopPropagation();
    setTimeout(() => {
      dropdown.classList.remove("open");
    }, 100);
  });

  setupOptionListeners(options, selectedText, dropdown);
}

function setDefaultOption(dropdown, options, selectedText) {
  const defaultOption = dropdown.getAttribute("data-default");
  if (defaultOption && defaultOption !== "") {
    const matchingOption = Array.from(options).find(
      (opt) => opt.getAttribute("data-value") === defaultOption
    );
    if (matchingOption) {
      selectedText.textContent = matchingOption.getAttribute("data-label");
      matchingOption.classList.add("selected");
    }
  }
}

function setupOptionListeners(options, selectedText, dropdown) {
  for (const option of options) {
    option.addEventListener("click", () => {
      const value = option.getAttribute("data-value");
      const label = option.textContent.trim();
      const filterParam = option.getAttribute("data-filter-param");

      selectedText.textContent = label;

      // Update selected class
      for (const opt of options) {
        opt.classList.remove("selected");
      }
      option.classList.add("selected");
      dropdown.classList.remove("open");

      navigateToOptionUrl(filterParam, value);
    });
  }
}

function checkUrlForSelection(dropdown, options) {
  const url = new URL(window.location.href);
  const paramValue = url.searchParams.get(dropdown.getAttribute('data-option-value'));
  if (paramValue) {
    const matchingOption = Array.from(options).find(
      (opt) => opt.getAttribute("data-value") === paramValue
    );
    if (matchingOption) {
      const selectedText = dropdown.querySelector(".selected-text");
      selectedText.textContent = matchingOption.textContent.trim();
      for (const option of options) {
        option.classList.remove("selected");
      }
      matchingOption.classList.add("selected");
    }
  }
}

function navigateToOptionUrl(filterParam, value) {
  const currentUrl = new URL(window.location.href);

  // Clean other filter params from URL
  const filterParams = ['catalog', 'sort_by', 'sortBy'];
  filterParams.forEach((key) => {
    if (key !== filterParam) {
      currentUrl.searchParams.delete(key);
    }
  });

  currentUrl.searchParams.set(filterParam, value);

  // Build filters object with only active values
  const inStockCheckbox = document.getElementById("boa-in-stock-filter");
  const filters = {
    catalog: filterParam === 'catalog' ? value : null,
    sortBy: filterParam === 'sortBy' ? value : null,
    inStock: inStockCheckbox?.checked || null,
  };

  // Apply the new URL state
  window.history.replaceState({}, "", currentUrl.toString());
  const searchQuery = currentUrl.searchParams.get("q");
  
  // Clean URL by removing 'q' and 'page' params
  currentUrl.searchParams.delete("page");
  window.history.replaceState({}, "", currentUrl);

  // Then do the fetch
  const collectionElements = document.querySelector(
    ".boa-collection-banner-container"
  );

  if (collectionElements) {
    const { collectionId } = collectionElements.dataset;
    fetchCollectionSearchResults(collectionId, 1, searchQuery, filters);
  } else {
    fetchSearchResults(1, searchQuery, filters);
  }
}

function setupEscapeKeyHandler() {
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const openDropdown = document.querySelector(
        ".boa-custom-dropdown.open"
      );
      if (openDropdown) {
        openDropdown.classList.remove("open");
      }
    }
  });
}
